import { Box, Link } from "@mui/material";
import { useLocales } from "../../../locales";
import { CommonWrap, ComomonAlert } from "../../common";
import Table from "../../../DocLayout/Table";
import CodeSnippet from "../../../components/CodeSnippet";
import ContentWrap from "../../../DocLayout/Content/Index";
import { Trans } from "react-i18next";
import {
  APP_WITHDRAW__RECORD,
  APP_WITHDRAW__RECORD_LIST,
  APP_WITHDRAW__TO_CWALLET,
  APP_WITHDRAW__TO_NETWORK,
} from "../../../config";
import { useContext } from "react";
import { ChooseCodeLanguageContext } from "@/components/ChooseCodeLanguage/ChooseCodeLanguage";
import { codeMap } from "@/PageCodeComponents/MerchantAPPModelAPI";
import PostRequest from "@/components/PostRequest";
export default function Index({
  url: APP_WITHDRAW__RECORD_,
  url_: APP_WITHDRAW__RECORD_LIST_,
  url_1: APP_WITHDRAW__TO_NETWORK_,
  url_2: APP_WITHDRAW__TO_CWALLET_,
}: {
  url: string;
  url_: string;
  url_1: string;
  url_2: string;
}) {
  const { translate, currentLang } = useLocales();
  const { language } = useContext(ChooseCodeLanguageContext);
  const withdraw_to_record = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "record": {
        "recordId": "202403120909501767478092588126208",
        "withdrawType": "Network",
        "coinId": 1891,
        "coinSymbol": "TETH",
        "chain": "POLYGON",
        "fromAddress": "0x1AE2828c18f9E3ae067F569aca1AE2828C4e7",
        "toAddress": "0xBb9C4e7F3687aca1AE2828c18f9E3ae067F569FE",
        "orderId": "1710234589577",
        "txId": "0xb55bb28292de56432b06204f71c68847a71670f2fc311af5c53a6ded45ab047b",
        "toMemo": "",
        "status": "Success",
        "amount": "0.004",
        "fee": {
          "coinId": 1891,
          "coinSymbol": "TETH",
          "amount": "0.001"
        }
      }
    }
  }
    `,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${APP_WITHDRAW__RECORD_}"
    args := []byte(${'`{"recordId": "202403010341121763409125674323968"}`'})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }      
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${APP_WITHDRAW__RECORD_}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("recordId", "202403010341121763409125674323968");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
        responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
        tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
        hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${APP_WITHDRAW__RECORD_}"
  content = {
    "recordId": '202403010341121763409125674323968',
    # "orderId": '17071162236'
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
  headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
  data=body
  )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${APP_WITHDRAW__RECORD_}";
  const args = JSON.stringify({
    "recordId": '202403010341121763409125674323968',
    //"orderId": '17071162236'
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${APP_WITHDRAW__RECORD_}";
  $content   =[ "recordId"=> '202403010341121763409125674323968'];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
      $sign_text = $sign_text . $body;
  } else {
      $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
      "headers" => array(
          "Content-Type: application/json;charset=utf-8",
          "Appid: " . $app_id,
          "Sign: " . $server_sign,
          "Timestamp: " . $timestamp
      ),
      "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const withdraw_to_record_list = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "records": [
        {
          "recordId": "202403120909501767478092588126208",
          "withdrawType": "Network",
          "coinId": 1891,
          "coinSymbol": "TETH",
          "chain": "POLYGON",
          "fromAddress": "0x1AE2828c18f9E3ae067F569aca1AE2828C4e7",
          "toAddress": "0xBb9C4e7F3687aca1AE2828c18f9E3ae067F569FE",
          "orderId": "1710234589577",
          "txId": "0xb55bb28292de56432b06204f71c68847a71670f2fc311af5c53a6ded45ab047b",
          "toMemo": "",
          "status": "Success",
          "amount": "0.004",
          "fee": {
            "coinId": 1891,
            "coinSymbol": "TETH",
            "amount": "0.001"
          }
        },
        {
          "recordId": "202403120913091767478929213362176",
          "withdrawType": "Cwallet",
          "coinId": 1329,
          "coinSymbol": "MATIC",
          "chain": "Cwallet OS",
          "cwalletUser": "35255142",
          "orderId": "1710234789039",
          "txId": "",
          "toMemo": "",
          "status": "Success",
          "amount": "0.002"
        }],
      "nextId": ""
    }
  }
    `,
    go: {
      http_ex_code: `package main
  
      import (
          "bytes"
          "crypto/hmac"
          "crypto/sha256"
          "encoding/hex"
          "fmt"
          "io"
          "net/http"
          "time"
      )
      
      func main() {
      
          appId := "*** your appId ***"
          appSecret := "*** your appSecret ***"
      
          // With request params
          path := "${APP_WITHDRAW__RECORD_LIST_}"
          args := []byte(${"`{}`"})
      
          //sign
          timestamp := time.Now().Unix()
      
          signText := fmt.Sprintf("%s%d", appId, timestamp)
          if len(args) != 0 {
              signText = fmt.Sprintf("%s%s", signText, args)
          }
      
          h := hmac.New(sha256.New, []byte(appSecret))
          h.Write([]byte(signText))
          sign := hex.EncodeToString(h.Sum(nil)[:])
      
          fmt.Printf("Sign: %s", sign)
      
          // Making API call
          client := http.Client{}
          request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
          request.Header.Set("Appid", appId)
          request.Header.Set("Sign", sign)
          request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
      
          resp, _ := client.Do(request)
      
          defer resp.Body.Close()
          respBytes, _ := io.ReadAll(resp.Body)
          fmt.Printf("Resp: %s", respBytes)
      }        
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${APP_WITHDRAW__RECORD_LIST_}";
  
    // params
    Map<String, Object> map = new HashMap<>();
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
      signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
      responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${APP_WITHDRAW__RECORD_LIST_}"
  content = {
    # "coinId": 1280,
    # "orderIds": ["1697445039666"],
    # "chain": "POLYGON",
    # "startAt": 1672506061,
    # "endAt": 1704042061,
    # "nextId": "46f62e0546f785cf961b922d024236aa",
  }
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${APP_WITHDRAW__RECORD_LIST_}";
  const args = JSON.stringify({
    //"coinId": 1280,
    //"orderIds": ["1697445039666"],
    //"chain": "POLYGON",
    //"startAt": 1672506061,
    //"endAt": 1704042061,
    //"nextId": "46f62e0546f785cf961b922d024236aa",
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${APP_WITHDRAW__RECORD_LIST_}";
  $content   =[];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
      $sign_text = $sign_text . $body;
  } else {
      $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
      "Content-Type: application/json;charset=utf-8",
      "Appid: " . $app_id,
      "Sign: " . $server_sign,
      "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const withdraw_to_network = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "recordId": "202403120909501767478092588126208"
    }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${APP_WITHDRAW__TO_NETWORK_}"
    args := []byte(${'`{"coinId": 1280,"address": "0xBb9C4e7F3687aca1AE2828c18f9E3ae067F569FE","orderId": "testorderId111","chain": "POLYGON","amount": "0.001"}'})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }
        
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${APP_WITHDRAW__TO_NETWORK_}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("coinId", 1280);
    map.put("address", "0xBb9C4e7F3687aca1AE2828c18f9E3ae067F569FE");
    map.put("orderId", "testorderId111");
    map.put("chain", "POLYGON");
    map.put("amount", "0.001");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
        responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
        tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
        hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${APP_WITHDRAW__TO_NETWORK_}"
  content = {
    "coinId": 1280,
    "address": "0xBb9C4e7F3687aca1AE2828c18f9E3ae067F569FE",
    "orderId": str(int(time.time() * 1000)),
    "chain": "POLYGON",
    "amount": "0.001",
    # "merchantPayNetworkFee": False,
    # "memo": ""
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
    sign_text = f"{sign_text}{body}"
  else:
    body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
  headers={
    "Content-Type": "application/json;charset=uf8",
    "Appid": app_id,
    "Sign": server_sign,
    "Timestamp": f"{timestamp}"},
  data=body
  )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${APP_WITHDRAW__TO_NETWORK_}";
  const args = JSON.stringify({
    "coinId": 1280,
    "address": "0xBb9C4e7F3687aca1AE2828c18f9E3ae067F569FE",
    "orderId": String(Math.floor(Date.now() / 1000)),
    "chain": "POLYGON",
    "amount": "0.001",
    //"merchantPayNetworkFee": False,
    //"memo": "" 
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${APP_WITHDRAW__TO_NETWORK_}";
  $content = ["coinId"=> 1280,
        "address"=> "0xBb9C4e7F3687aca1AE2828c18f9E3ae067F569FE",
        "orderId"=> "testorderId111",
        "chain"=> "POLYGON",
        "amount"=> "0.001"];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
    $sign_text = $sign_text . $body;
  } else {
    $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
    "headers" => array(
        "Content-Type: application/json;charset=utf-8",
        "Appid: " . $app_id,
        "Sign: " . $server_sign,
        "Timestamp: " . $timestamp
    ),
    "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  const withdraw_to_cwallet = {
    response: `{
    "code": 10000,
    "msg": "success",
    "data": {
      "recordId": "202403120913091767478929213362176"
    }
  }`,
    go: {
      http_ex_code: `package main
  
  import (
    "bytes"
    "crypto/hmac"
    "crypto/sha256"
    "encoding/hex"
    "fmt"
    "io"
    "net/http"
    "time"
  )
  
  func main() {
  
    appId := "*** your appId ***"
    appSecret := "*** your appSecret ***"
  
    // With request params
    path := "${APP_WITHDRAW__TO_CWALLET_}"
    args := []byte(${'`{"coinId": 1280,"cwalletUser": "9558861","orderId": "testorderid1121241","amount": "0.002"}`'})
  
    //sign
    timestamp := time.Now().Unix()
  
    signText := fmt.Sprintf("%s%d", appId, timestamp)
    if len(args) != 0 {
        signText = fmt.Sprintf("%s%s", signText, args)
    }
  
    h := hmac.New(sha256.New, []byte(appSecret))
    h.Write([]byte(signText))
    sign := hex.EncodeToString(h.Sum(nil)[:])
  
    fmt.Printf("Sign: %s", sign)
  
    // Making API call
    client := http.Client{}
    request, _ := http.NewRequest(http.MethodPost, path, bytes.NewBuffer(args))
    request.Header.Set("Appid", appId)
    request.Header.Set("Sign", sign)
    request.Header.Set("Timestamp", fmt.Sprintf("%d", timestamp))
  
    resp, _ := client.Do(request)
  
    defer resp.Body.Close()
    respBytes, _ := io.ReadAll(resp.Body)
    fmt.Printf("Resp: %s", respBytes)
  }      
  `,
      example_code: ``,
      example_code2: ``,
    },
    java: {
      http_ex_code: `package com.CCPayment.apis;
  
  import java.nio.charset.StandardCharsets;
  import java.security.InvalidKeyException;
  import java.security.NoSuchAlgorithmException;
  import javax.crypto.Mac;
  import javax.crypto.spec.SecretKeySpec;
  
  import com.fasterxml.jackson.databind.ObjectMapper;
  import com.fasterxml.jackson.databind.SerializationFeature;
  import org.apache.http.HttpResponse;
  import org.apache.http.client.HttpClient;
  import org.apache.http.client.methods.HttpPost;
  import org.apache.http.entity.ByteArrayEntity;
  import org.apache.http.impl.client.HttpClientBuilder;
  import java.io.BufferedReader;
  import java.io.IOException;
  import java.io.InputStreamReader;
  import java.util.Date;
  import java.util.HashMap;
  import java.util.Map;
  
  public class paymentApi {
  public static void main(String[] args) throws NoSuchAlgorithmException, InvalidKeyException, IOException {
    String appId = "*** your appId ***";
    String appSecret = "*** your appSecret ***";
    // With request params
    String path = "${APP_WITHDRAW__TO_CWALLET_}";
  
    // params
    Map<String, Object> map = new HashMap<>();
    map.put("coinId", 1280);
    map.put("cwalletUser", "9558861");
    map.put("orderId", "testorderid1121241");
    map.put("amount", "0.002");
  
    ObjectMapper mapper = new ObjectMapper();
    mapper.configure(SerializationFeature.FAIL_ON_EMPTY_BEANS, false);
    String inputString = mapper.writeValueAsString(map);
  
    byte[] requestBody = inputString.getBytes(StandardCharsets.UTF_8);
    // Sign
    long timestamp = new Date().getTime() / 1000L;
    String signText = appId + timestamp;
    if (requestBody.length != 0) {
        signText += new String(requestBody, StandardCharsets.UTF_8);
    }
    Mac sha256Hmac = Mac.getInstance("HmacSHA256");
    SecretKeySpec secretKey = new SecretKeySpec(appSecret.getBytes(StandardCharsets.UTF_8), "HmacSHA256");
    sha256Hmac.init(secretKey);
    byte[] signBytes = sha256Hmac.doFinal(signText.getBytes(StandardCharsets.UTF_8));
    String sign = byteArrayToHexString(signBytes);
  
    // Making API call
    HttpClient client = HttpClientBuilder.create().build();
    HttpPost request = new HttpPost(path);
    request.setHeader("Appid", appId);
    request.setHeader("Sign", sign);
    request.setHeader("Timestamp", String.valueOf(timestamp));
    request.setEntity(new ByteArrayEntity(requestBody));
    HttpResponse response = client.execute(request);
    BufferedReader reader = new BufferedReader(new InputStreamReader(response.getEntity().getContent()));
    StringBuilder responseText = new StringBuilder();
    String line;
    while ((line = reader.readLine()) != null) {
      responseText.append(line);
    }
    reader.close();
  
    // result
    System.out.println("Resp: " + responseText);
  }
  
  private static String byteArrayToHexString(byte[] bytes) {
    StringBuilder hs = new StringBuilder();
    String tempStr;
    for (int index = 0; bytes != null && index < bytes.length; index++) {
      tempStr = Integer.toHexString(bytes[index] & 0XFF);
      if (tempStr.length() == 1) {
          hs.append('0');
      }
      hs.append(tempStr);
    }
    return hs.toString().toLowerCase();
  }
  }`,
      example_code: ``,
      example_code2: ``,
    },
    python: {
      http_ex_code: `# Python 3.9
  import json
  import time
  import hmac
  import hashlib
  import binascii
  import requests
  
  app_id = "*** your app_id ***"
  app_secret = "*** your app_secret ***"
  url = "${APP_WITHDRAW__TO_CWALLET_}"
  content = {
      "coinId": 1280,
      "cwalletUser": '9558861',
      "orderId": str(int(time.time() * 1000)),
      "amount": "1"
  }
  
  timestamp = int(time.time())
  body = json.dumps(content)
  sign_text = f"{app_id}{timestamp}"
  if len(body) != 2:
      sign_text = f"{sign_text}{body}"
  else:
      body = ""
  
  h = hmac.new(app_secret.encode('utf-8'), sign_text.encode('utf-8'), hashlib.sha256)
  server_sign = binascii.hexlify(h.digest()).decode('utf-8')
  
  res = requests.post(url=url,
    headers={
      "Content-Type": "application/json;charset=uf8",
      "Appid": app_id,
      "Sign": server_sign,
      "Timestamp": f"{timestamp}"},
    data=body
    )
  print(res.json())`,
      example_code: ``,
      example_code2: ``,
    },
    javascript: {
      http_ex_code: `const https = require("https");
  const crypto = require("crypto");
  
  const appId = "*** your appId ***";
  const appSecret = "*** your appSecret ***";
  
  const path = "${APP_WITHDRAW__TO_CWALLET_}";
  const args = JSON.stringify({
    "coinId": 1280,
    "cwalletUser": '9558861',
    "orderId": String(Math.floor(Date.now() / 1000)),
    "amount": "0.002"
  });
  
  const timestamp = Math.floor(Date.now() / 1000);
  let signText = appId + timestamp;
  if (args.length !== 0) {
    signText += args;
  }
  
  const sign = crypto
    .createHmac("sha256", appSecret)
    .update(signText)
    .digest("hex");
  
  const options = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Appid": appId,
      "Sign": sign,
      "Timestamp": timestamp.toString(),
    },
  };
  
  const req = https.request(path, options, (res) => {
    let respData = "";
  
    res.on("data", (chunk) => {
      respData += chunk;
    });
  
    res.on("end", () => {
      console.log("Response:", respData);
    });
  });
  
  req.write(args);
  req.end();`,
      example_code: ``,
      example_code2: ``,
    },
    php: {
      http_ex_code: `<?php
  $app_id = "*** your app_id ***";
  $app_secret = "*** your app_secret ***";
  $url = "${APP_WITHDRAW__TO_CWALLET_}";
  $content   =[ "coinId"=> 1280,
    "cwalletUser"=> "9558861",
    "orderId"=> "testorderid112124156",
    "amount"=> "0.002"];
  
  $timestamp = time();
  $body = json_encode($content);
  $sign_text = $app_id . $timestamp;
  if (strlen($body) != 2) {
  $sign_text = $sign_text . $body;
  } else {
  $body = "";
  }
  
  $server_sign = hash_hmac('sha256', $sign_text, $app_secret);
  
  $data = array(
  "headers" => array(
    "Content-Type: application/json;charset=utf-8",
    "Appid: " . $app_id,
    "Sign: " . $server_sign,
    "Timestamp: " . $timestamp
  ),
  "body" => $body
  );
  
  $ch = curl_init();
  curl_setopt($ch, CURLOPT_URL, $url);
  curl_setopt($ch, CURLOPT_POST, true);
  curl_setopt($ch, CURLOPT_POSTFIELDS, $data['body']);
  curl_setopt($ch, CURLOPT_HTTPHEADER, $data['headers']);
  curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
  
  $response = curl_exec($ch);
  curl_close($ch);
  
  $result = json_decode($response, true);
  print_r($result);
  ?>`,
      example_code: ``,
      example_code2: ``,
    },
  };
  return (
    <div>
      {/* 提现相关API */}
      <ContentWrap
        id="withdrawal-api"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title">
              {translate("merchant_app_mode_API.text_67")}
            </Box>
            <Box id="create-network-withdrawal-order" className="title_0">
              {translate("merchant_app_mode_API.text_68")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_69")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_70")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_WITHDRAW__TO_NETWORK} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "address",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_43")}`,
                },
                {
                  name: "memo",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_19_"
                  )}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_app_mode_API.text_88_")}`,
                },
                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
                {
                  name: "merchantPayNetworkFee",
                  type: "Boolean",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            "merchant_app_mode_API.text_71"
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={withdraw_to_network[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 提现相关API 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_46")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["withdraw_to_network"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />

      {/* Webhook 通知 - API withdrawal */}
      <ContentWrap
        id="webhook-for-api-withdrawal"
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_72")}
            </Box>

            {currentLang?.value === "en" ? (
              <Box mb={3}>
                <Trans
                  i18nKey={"merchant_app_mode_API.text_73_"}
                  t={translate as any}
                >
                  s
                  <a href={"#get-withdrawal-record"} className="link">
                    s
                  </a>
                  s
                </Trans>
              </Box>
            ) : (
              <Box component={"div"} className="desc">
                <div
                  className="code"
                  dangerouslySetInnerHTML={{
                    __html: translate("merchant_app_mode_API.text_73") as any,
                  }}
                />
              </Box>
            )}

            <Box mt={3} className="title_1">
              {translate("merchant_user_wallet_mode_API.text_49")}
            </Box>
            <Table
              res
              tableData={[
                {
                  name: "type",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_118"),
                },
                {
                  name: "msg",
                  type: "Object",
                  desc: "",
                },
                {
                  name: "msg.recordId",
                  type: "String",
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "msg.orderId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_29")}`,
                },
                {
                  name: "msg.coinId",
                  type: "Integer",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "msg.coinSymbol",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_symbol"
                  )}`,
                },
                {
                  name: "msg.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_app_mode_API.text_85"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              {translate("merchant_user_wallet_mode_API.text_50")}
              <br />
              {currentLang?.value !== "en" && (
                <div
                  className="code"
                  dangerouslySetInnerHTML={{
                    __html: translate(
                      "merchant_user_wallet_mode_API.text_51"
                    ) as any,
                  }}
                />
              )}
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={`{
  "type": "ApiWithdrawal",
  "msg": {
    "recordId": "20240313120722176788...",
    "orderId": "6322851679...",
    "coinId": 1891,
    "coinSymbol": "TETH",
    "status": "Success"
  }
}`}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />

      {/* 提现到Cwallet账户  */}
      <ContentWrap
        id="withdrawal-to-cwallet-account"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_1">
              {translate("merchant_app_mode_API.text_74")}
            </Box>
            <Box className="desc code">
              {translate("merchant_app_mode_API.text_75")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <span className="desc mr-1">POST</span>
              <Link
                href={APP_WITHDRAW__TO_CWALLET}
                target="_blank"
                rel="noopener"
                className="link"
                underline="always"
              >
                {APP_WITHDRAW__TO_CWALLET}
              </Link>{" "}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "cwalletUser",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_54"
                        ) as any,
                      }}
                    />
                  ),
                },

                {
                  name: "amount",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_55")}`,
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_is")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API._text_44"
                  )}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={withdraw_to_cwallet[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 提现到Cwallet账户  返回*/}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.recordId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_46_"
                  )}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_56"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["withdraw_to_cwallet"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取提现记录 */}
      <ContentWrap
        id="get-withdrawal-record"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("merchant_app_mode_API.text_76")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_77")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_WITHDRAW__RECORD} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "recordId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: translate("merchant_user_wallet_mode_API.text_14"),
                },
                {
                  name: "orderId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API._text_44"
                  )}`,
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    "merchant_user_wallet_mode_API.text_59_"
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={withdraw_to_record[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取提现记录 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.record",
                  type: "Object",
                  desc: "",
                },

                {
                  name: "data.record.recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.record.withdrawType",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_64_"
                        ) as any,
                      }}
                    />
                  ),
                },

                {
                  name: "data.record.coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_63")}`,
                },
                {
                  name: "data.record.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_64")}`,
                },
                {
                  name: "data.record.chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "data.record.cwalletUser",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_65")}`,
                },
                {
                  name: "data.record.fromAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_78_")}`,
                },
                {
                  name: "data.record.toAddress",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_78")}`,
                },
                {
                  name: "data.record.toMemo",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_79")}`,
                },
                {
                  name: "data.record.txId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_80")}`,
                },
                {
                  name: "data.record.status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          `${
                            currentLang.value === "en"
                              ? "merchant_app_mode_API"
                              : "merchant_user_wallet_mode_API"
                          }.text_85_`
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.record.orderId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_88")}`,
                },
                {
                  name: "data.record.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
                {
                  name: "data.record.fee",
                  type: "Object",
                  desc: `${translate("merchant_user_wallet_mode_API.text_69")}`,
                },
                {
                  name: "data.record.fee.coinId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_92")}`,
                },
                {
                  name: "data.record.fee.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_70")}`,
                },
                {
                  name: "data.record.fee.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_71")}`,
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["withdraw_to_record"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取提现记录列表 */}
      <ContentWrap
        id="get-withdrawal-record-list"
        showBorderBottom={false}
        leftChildren={
          <CommonWrap>
            <Box className="title_0">
              {translate("merchant_app_mode_API.text_82")}
            </Box>
            <Box className="desc">
              {translate("merchant_app_mode_API.text_83")}
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_request")}
            </Box>
            <Box className="desc link">
              <PostRequest url={APP_WITHDRAW__RECORD_LIST} />
            </Box>
            <Box mt={3} className="title_1">
              {translate("common.http_params")}
            </Box>
            <Table
              tableData={[
                {
                  name: "coinId",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.response_coin_id"
                  )}`,
                },
                {
                  name: "orderIds",
                  type: "Array[string]",
                  is_: `${translate("common.params_no")}`,
                  desc: translate("merchant_app_mode_API.text_84"),
                },
                {
                  name: "chain",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },
                {
                  name: "startAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_28"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "endAt",
                  type: "Integer",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_29"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "nextId",
                  type: "String",
                  is_: `${translate("common.params_no")}`,
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_30"
                        ) as any,
                      }}
                    />
                  ),
                },
              ]}
            />
            <ComomonAlert sx={{ mt: 2 }}>
              <div
                className="code"
                dangerouslySetInnerHTML={{
                  __html: translate(
                    `merchant_user_wallet_mode_API.${
                      currentLang?.value === "en" ? "text_32" : "text_31"
                    }`
                  ) as any,
                }}
              />
            </ComomonAlert>
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_request_ex")}
            code={withdraw_to_record_list[language].http_ex_code}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
      {/* 获取提现记录列表 返回参数 */}
      <ContentWrap
        leftChildren={
          <CommonWrap>
            <Box className="title_1">{translate("common.http_res")}</Box>
            <Table
              res
              tableData={[
                {
                  name: "data",
                  type: "Object",
                  desc: ``,
                },
                {
                  name: "data.records",
                  type: "Array",
                  desc: "",
                },

                {
                  name: "data.records[index].recordId",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_14")}`,
                },
                {
                  name: "data.records[index].withdrawType",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_64_"
                        ) as any,
                      }}
                    />
                  ),
                },

                {
                  name: "data.records[index].coinId",
                  type: "Integer",
                  desc: `${translate("merchant_user_wallet_mode_API.text_63")}`,
                },
                {
                  name: "data.records[index].coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_64")}`,
                },
                {
                  name: "data.records[index].chain",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_3")}`,
                },

                {
                  name: "data.records[index].orderId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_44_"
                  )}`,
                },
                {
                  name: "data.records[index].cwalletUser",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_65")}`,
                },
                {
                  name: "data.records[index].fromAddress",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_74_"
                  )}`,
                },
                {
                  name: "data.records[index].toAddress",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_74")}`,
                },
                {
                  name: "data.records[index].toMemo",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_75")}`,
                },
                {
                  name: "data.records[index].amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_45")}`,
                },
                {
                  name: "data.records[index].txId",
                  type: "String",
                  desc: `${translate(
                    "merchant_user_wallet_mode_API.text_68_"
                  )}`,
                },
                {
                  name: "data.records[index].status",
                  type: "String",
                  desc: (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: translate(
                          "merchant_user_wallet_mode_API.text_85_"
                        ) as any,
                      }}
                    />
                  ),
                },
                {
                  name: "data.records[index].fee",
                  type: "Object",
                  desc: `${translate("merchant_user_wallet_mode_API.text_69")}`,
                },
                {
                  name: "data.records[index].fee.coinId",
                  type: "String",
                  desc: `${translate("merchant_app_mode_API.text_92")}`,
                },
                {
                  name: "data.records[index].fee.coinSymbol",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_70")}`,
                },
                {
                  name: "data.records[index].fee.amount",
                  type: "String",
                  desc: `${translate("merchant_user_wallet_mode_API.text_71")}`,
                },
                {
                  name: "data.nextId",
                  type: "String",
                  desc: (
                    <div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: `${translate(
                            `merchant_user_wallet_mode_API.${
                              currentLang?.value === "en"
                                ? "text_32"
                                : "text_30_"
                            }`
                          )}` as any,
                        }}
                      />
                    </div>
                  ),
                },
              ]}
            />
          </CommonWrap>
        }
        rightChildren={
          <CodeSnippet
            title={translate("common.http_result")}
            code={codeMap["withdraw_to_record_list"].response}
          />
        }
        rightChildrenSx={{
          pt: 8,
        }}
      />
    </div>
  );
}
